import type { ComponentProps } from "react";

import { cn } from "../../utils";
import { ChevronRightIcon } from "../icons";

export const Separator = ({ className, ...props }: ComponentProps<"li">) => (
  <li role="presentation" aria-hidden="true" className={cn("[&>svg]:size-3.5", className)} {...props}>
    <ChevronRightIcon className="h-5 w-5 text-neutral-0" />
  </li>
);

export default Separator;
